import { MouseEventHandler, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const JohnDeereConnectSuccess = () => {
  const [countdown, setCountdown] = useState(10);
  const units = countdown === 1 ? "segundo" : "segundos";

  const closeWindow = (e: any) => {
    // e.preventDefault();
    doCloseWindow();
  };

  const doCloseWindow = () => {
    console.log("Reloading parent window...")
    window.opener?.location.reload();
    window.close();
  };

  useEffect(() => {
    window.onbeforeunload = doCloseWindow;
  }, []);

  useEffect(() => {
    countdown > 0 && setTimeout(() => setCountdown(countdown - 1), 1000);
    if (countdown === 0) doCloseWindow();
  }, [countdown]);
  return (
    <div>
      <h2>Conexión a John Deere existosa</h2>
      <p>Esta ventana se cerrará automaticamente en {countdown} {units}. <a href="" onClick={() => closeWindow}>[Cerrar ahora]</a></p>
    </div>
  );
}

export default JohnDeereConnectSuccess;